import ReactGA from 'react-ga';

export function shouldUpdateScroll(prevRouterProps, { location }) {
  const noScrollSections = ['data', 'compare'];

  const path = (prevRouterProps && prevRouterProps.location.pathname.split('/')[1]) || '';
  const nextPath = location.pathname.split('/')[1];

  return !(path === nextPath && noScrollSections.indexOf(nextPath) > -1);
}

export function trackPageView() {
  let currentUrl = window.location.pathname;

  if (window.location.search) {
    currentUrl += window.location.search;
  }

  ReactGA.set({ page: currentUrl });
  ReactGA.pageview(currentUrl);
}



// WEBPACK FOOTER //
// ./app/routes/actions/index.js